module.exports = __webpack_public_path__ + "img/event-frame01.2f7282e2.png";